import { useEffect, useContext } from "react";
import LogoInverted from "../../Images/static/media/logos/kalo-logo-inverted.svg";
import LogoNoventic from "../../Images/static/media/icons/logo-noventic.png";

import CalculatorContext from "../../Context/CalculatorContext";

const { REACT_APP_PUBLIC_URL } = process.env;

/* eslint-disable max-len */
function Footer() {
  const { co2Prices } = useContext(CalculatorContext);

  useEffect(() => {
    const handleModalHide = (event) => {
      const modal = event.target;
      if (document.activeElement && modal && modal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    };

    const modals = document.querySelectorAll("#page-footer .modal");

    modals.forEach((modal) => {
      modal.addEventListener("hide.bs.modal", handleModalHide);
    });

    return () => {
      modals.forEach((modal) => {
        modal.removeEventListener("hide.bs.modal", handleModalHide);
      });
    };
  }, []);

  return (
    <footer id="page-footer" className="bp-page-footer" role="contentinfo">
      <section className="section footer-section footer-section-meta">
        <div className="frame frame-background-none">
          <div className="frame-group-container">
            <div className="frame-group-inner">
              <div className="frame-container frame-container-default">
                <div className="frame-inner">
                  <div className="footer-brand">
                    <div className="row">
                      <div className="col-md-6">
                        <a
                          className="navbar-brand navbar-brand-image"
                          href={REACT_APP_PUBLIC_URL}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="navbar-brand-logo-inverted"
                            src={LogoInverted}
                            alt="KALO - Einfach. Innovativ. Persönlich. logo"
                            height="52"
                            width="180"
                          />
                        </a>
                      </div>
                      <div className="col-md-6">
                        <div className="footer-sociallinks">
                          <div className="sociallinks">
                            <ul className="sociallinks-list">
                              {/* <li
                                className="sociallinks-item sociallinks-item-62ac79bb21aa5711762323"
                                title="twitter"
                              >
                                <a
                                  className="btn btn-icon btn-icon-secondary sociallinks-link sociallinks-link-62ac79bb21aa5711762323"
                                  href="https://twitter.com/kalorimeta"
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  <i className="sociallinks-link-icon icon-twitter-icon" />
                                  <span className="sociallinks-link-label" />
                                </a>
                              </li> */}
                              <li
                                className="sociallinks-item sociallinks-item-62ac79c35ad39255558289"
                                title="linkedin"
                              >
                                <a
                                  className="btn btn-icon btn-icon-secondary sociallinks-link sociallinks-link-62ac79c35ad39255558289"
                                  href="https://www.linkedin.com/company/kalorimeta-gmbh/"
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  aria-label="KALO LinkedIn link"
                                >
                                  <i className="sociallinks-link-icon icon-linkedin-icon" />
                                  <span className="sociallinks-link-label" />
                                </a>
                              </li>
                              <li
                                className="sociallinks-item sociallinks-item-62ac79cbefd77183611003"
                                title="xing"
                              >
                                <a
                                  className="btn btn-icon btn-icon-secondary sociallinks-link sociallinks-link-62ac79cbefd77183611003"
                                  href="https://www.xing.com/pages/kalo"
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  aria-label="KALO Xing link"
                                >
                                  <i className="sociallinks-link-icon icon-xing-icon" />
                                  <span className="sociallinks-link-label" />
                                </a>
                              </li>
                              <li
                                className="sociallinks-item sociallinks-item-62ac79d59737a932079692"
                                title="youtube"
                              >
                                <a
                                  className="btn btn-icon btn-icon-secondary sociallinks-link sociallinks-link-62ac79d59737a932079692"
                                  href="https://www.youtube.com/channel/UCncuPbzds1mc0CcaF__8eHg"
                                  rel="noopener noreferrer"
                                  target="_blank"
                                  aria-label="KALO youtube link"
                                >
                                  <i className="sociallinks-link-icon icon-youtube-icon" />
                                  <span className="sociallinks-link-label" />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="footer-meta">
                    <ul id="meta_menu" className="meta-menu">
                      <li className="active">
                        <a
                          className="link-title"
                          href={`${REACT_APP_PUBLIC_URL}/dienstleistungen/heizkostenabrechnung/`}
                          title="Dienstleistungen"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span>Dienstleistungen</span>
                        </a>
                        <ul className="sub-menu">
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/dienstleistungen/heizkostenabrechnung/`}
                              className="sub-item"
                              title="Heizkostenabrechnung"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Heizkostenabrechnung</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/dienstleistungen/betriebskostenabrechnung/`}
                              className="sub-item"
                              title="Betriebskostenabrechnung"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Betriebskostenabrechnung</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/dienstleistungen/smart-metering-multi-metering/`}
                              className="sub-item"
                              title="Smart Metering &amp; Multi-Metering"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Smart Metering &amp; Multi-Metering</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/dienstleistungen/smarte-thermostatsteuerung/`}
                              className="sub-item"
                              title="Smarte Thermostatsteuerung"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Smarte Thermostatsteuerung</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/dienstleistungen/unterjaehrige-verbrauchsinformation-uvi/`}
                              className="sub-item"
                              title="Unterjährige Verbrauchsinformation (UVI)"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">
                                Unterjährige Verbrauchsinformation (UVI)
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/dienstleistungen/rauchwarnmelder-service/`}
                              className="sub-item"
                              title="Rauchwarnmelder-Service"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Rauchwarnmelder-Service</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/dienstleistungen/energieausweis/`}
                              className="sub-item"
                              title="Energieausweis"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Energieausweis</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="active">
                        <a
                          className="link-title"
                          href={`${REACT_APP_PUBLIC_URL}/geraete-hardware/funksystem/`}
                          title="Geräte &amp; Hardware"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span>Geräte &amp; Hardware</span>
                        </a>
                        <ul className="sub-menu">
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/geraete-hardware/funksystem/`}
                              className="sub-item"
                              title="Funksystem"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Funksystem</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/geraete-hardware/smart-meter-gateway-cls-adapter/`}
                              className="sub-item"
                              title="Smart-Meter-Gateway &amp; CLS-Adapter"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">
                                Smart-Meter-Gateway &amp; CLS-Adapter
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/geraete-hardware/heizkostenverteiler/`}
                              className="sub-item"
                              title="Heizkostenverteiler"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Heizkostenverteiler</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/geraete-hardware/waermezaehler/`}
                              className="sub-item"
                              title="Wärmezähler"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Wärmezähler</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/geraete-hardware/wasserzaehler/`}
                              className="sub-item"
                              title="Wasserzähler"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Wasserzähler</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/geraete-hardware/rauchwarnmelder/`}
                              className="sub-item"
                              title="Rauchwarnmelder"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Rauchwarnmelder</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="active">
                        <a
                          className="link-title"
                          href={`${REACT_APP_PUBLIC_URL}/rechtliches/novellierte-heizkostenverordnung/`}
                          title="Rechtliches"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span>Rechtliches</span>
                        </a>
                        <ul className="sub-menu">
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/novellierte-heizkostenverordnung/`}
                              className="sub-item"
                              title="Die Neuerungen der novellierten Heizkostenverordnung"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">
                                Die Neuerungen der novellierten Heizkostenverordnung
                              </span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/die-heizkostenverordnung/`}
                              className="sub-item"
                              title="Die Heizkostenverordnung"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Die Heizkostenverordnung</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/rohrwaerme-vdi-2077/`}
                              className="sub-item"
                              title="Rohrwärme (VDI 2077)"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Rohrwärme (VDI 2077)</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/rauchwarnmelderpflicht/`}
                              className="sub-item"
                              title="Rauchwarnmelderpflicht"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Rauchwarnmelderpflicht</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/mess-und-eichverordnung/`}
                              className="sub-item"
                              title="Mess- und Eichverordnung"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Mess- und Eichverordnung</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/ensikumav/`}
                              className="sub-item"
                              title="EnSikuMaV"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">EnSikuMaV</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/soforthilfe-dezember/`}
                              className="sub-item"
                              title="Soforthilfe Dezember"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Soforthilfe Dezember</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/energiepreisbremse/`}
                              className="sub-item"
                              title="Energiepreisbremse"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Energiepreisbremse</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/das-co2-kostenaufteilungsgesetz/`}
                              className="sub-item"
                              title="Das CO2-Kostenaufteilungsgesetz"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">
                                Das CO<sub>2</sub>-Kostenaufteilungsgesetz
                              </span>
                            </a>
                          </li>
                          <li className="sub-divider" />
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/datenschutz/`}
                              className="sub-item"
                              title="Datenschutz"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Datenschutz</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/agb/`}
                              className="sub-item"
                              title="AGB"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">AGB</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/rechtliches/impressum/`}
                              className="sub-item"
                              title="Impressum"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Impressum</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="active">
                        <a
                          className="link-title"
                          href={`${REACT_APP_PUBLIC_URL}/unternehmen/ueber-uns/`}
                          title="Unternehmen"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span>Unternehmen</span>
                        </a>
                        <ul className="sub-menu">
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/unternehmen/ueber-uns/`}
                              className="sub-item"
                              title="Über uns"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Über uns</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/unternehmen/corporate-purpose/`}
                              className="sub-item"
                              title="Corporate Purpose"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Corporate Purpose</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/unternehmen/management-team/`}
                              className="sub-item"
                              title="Managementteam"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Managementteam</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/unternehmen/unternehmensgruppe/`}
                              className="sub-item"
                              title="Unternehmensgruppe"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Unternehmensgruppe</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/unternehmen/nachhaltigkeitsprojekte/`}
                              className="sub-item"
                              title="Nachhaltigkeitsprojekte"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Nachhaltigkeitsprojekte</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="active">
                        <a
                          className="link-title"
                          href={`${REACT_APP_PUBLIC_URL}/news-infos/news/`}
                          title="News &amp; Infos"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span>News &amp; Infos</span>
                        </a>
                        <ul className="sub-menu">
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/news-infos/news/`}
                              className="sub-item"
                              title="News"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">News</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/news-infos/webinare/`}
                              className="sub-item"
                              title="Webinare"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Webinare</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/news-infos/downloads/`}
                              className="sub-item"
                              title="Downloads"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Downloads</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/news-infos/faq/`}
                              className="sub-item"
                              title="FAQ"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">FAQ</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <ul className="sub-menu">
                          <li>
                            <a
                              className="link-title"
                              href={`${REACT_APP_PUBLIC_URL}/kontaktformular/`}
                              title="Kontakt"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span>Kontakt</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/kontaktformular/`}
                              className="sub-item"
                              title="Kontaktformular"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Kontaktformular</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href={`${REACT_APP_PUBLIC_URL}/kontakt/ansprechpartner-vor-ort/`}
                              className="sub-item"
                              title="Ansprechpartnersuche"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span className="sub-text">Ansprechpartnersuche</span>
                            </a>
                          </li>

                          <li className="sub-divider" />
                          <li>
                            <a
                              className="link-title"
                              href={`${REACT_APP_PUBLIC_URL}/karriere/`}
                              title="Karriere"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span>Karriere</span>
                            </a>
                          </li>
                          <li>
                            <a
                              className="link-title"
                              href={`${REACT_APP_PUBLIC_URL}/kundenportal/`}
                              title="Kundenportal"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <span>Kundenportal</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div className="footer-copyright">
                    <span> @ {new Date().getFullYear()} KALORIMETA GmbH</span>
                    <div className="footer-additional-logo">
                      <span className="label-title">Ein Unternehmen der</span>
                      <picture>
                        <img
                          loading="lazy"
                          src={LogoNoventic}
                          className="img-fluid"
                          width="176"
                          height="24"
                          intrinsicsize="176x24"
                          title=""
                          alt=""
                        />
                      </picture>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        className="modal fade"
        id="floatinTrigerSocial"
        tabIndex="-1"
        aria-labelledby="floatinTrigerSocialLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-tertiary">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="floatinTrigerSocialLabel">
                <span className="text-primary">
                  CO<sub>2</sub>-Gesamtkosten
                </span>{" "}
                auf 10 Jahre
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p className="text-large">
                Für eine umfassende Planung, haben wir für Sie voraussichtliche CO<sub>2</sub>
                -Abgaben, basierend auf ihren Angaben kalkuliert. Diese Kalkulation erstreckt sich
                über eine Zeitspanne von 10 Jahren. Die Summe beinhaltet die Kosten, die sowohl
                Vermieter als auch Bewohner tragen müssen.
              </p>

              <br />

              <p className="text-large">
                <a
                  href="#"
                  target="_blank"
                  className="btn btn-default"
                  rel="noreferrer"
                  data-bs-dismiss="modal"
                >
                  Schließen
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="fernwarme"
        tabIndex="-1"
        aria-labelledby="fernwarmeLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-tertiary">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="floatinTrigerSocialLabel">
                Hinweis zur Eingabe{" "}
                <span className="text-primary">
                  Ihres CO<sub>2</sub>-Emissionsfaktors
                </span>
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p className="text-large">
                Ihren individuellen CO<sub>2</sub>-Emissionsfaktor erfahren Sie von Ihrem
                Energieversorger. Mit dem Wert erhalten Sie eine genauere CO<sub>2</sub>
                -Kosten-Prognose, da der Emissionsfaktor von Fernwärme je nach dem Energiemix sowie
                lokale Gegebenheiten stark variieren kann.
              </p>

              <br />

              <p className="text-large">
                <a
                  href="#"
                  target="_blank"
                  className="btn btn-default"
                  rel="noreferrer"
                  data-bs-dismiss="modal"
                >
                  Schließen
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="floatinTrigerContact"
        tabIndex="-1"
        aria-labelledby="floatinTrigerContactLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-tertiary">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="floatinTrigerContactLabel">
                <span className="text-primary">
                  CO<sub>2</sub>-Kostenprognose
                </span>{" "}
                für 10 Jahre
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p>
                {Object.keys(co2Prices)[0] === "2025" && (
                  <span>
                    Der CO<sub>2</sub>-Preis wurde im Jahr 2025 gesetzlich festgelegt auf 55 Euro
                    Euro pro Tonne CO<sub>2</sub>.{" "}
                  </span>
                )}
                In den Jahren 2026 und 2027 werden Emissionszertifikate erstmalig versteigert. Für
                diesen Zeitraum gilt ein gesetzlicher Preiskorridor zwischen 55 und 65 Euro pro CO
                <sub>2</sub>.
              </p>
              <p>
                Ab dem Jahr 2028 wird der Preis durch den freien Handel im europäischen
                Emissionshandelssystem (EU-ETS) bestimmt. Expert:innen rechnen damit, dass sich die
                Preise bis 2030 deutlich erhöhen könnten. In verschiedenen Szenarien ist sogar von
                bis zu 275 Euro pro Tonne CO<sub>2</sub> die Rede.
              </p>
              <p>
                Die dargestellte CO<sub>2</sub>-Kostenprognose basiert je nach Auswahl auf den von
                Ihnen eingegebenen oder auf voreingestellten Preisen pro Tonne CO<sub>2</sub>.
              </p>
              <p>
                <strong>Hinweis:</strong> Es handelt sich um Einschätzungen auf Basis aktueller
                Studien und Marktentwicklungen. Eine verbindliche Vorhersage von zukünftigen
                Preisen, die über das europäische Emissionshandelssystem ermittelt werden, ist zum
                jetzigen Zeitpunkt nicht möglich.
              </p>
              <br />

              <p className="text-large">
                <a
                  href="#"
                  target="_blank"
                  className="btn btn-default"
                  rel="noreferrer"
                  data-bs-dismiss="modal"
                >
                  Schließen
                </a>
              </p>
            </div>
          </div>
        </div>
        <div id="svg-icons" className="icon-container">
          <div>
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <symbol viewBox="0 0 26 28" id="icon-arrow-down">
                <title>Icon feather-arrow-down</title>
                <desc>Generated with Avocode.</desc>
                <g>
                  <g>
                    <g>
                      <path
                        d="M12.58987,1.13062v20.46041"
                        fillOpacity="0"
                        fill="#ffffff"
                        strokeDashoffset="0"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        strokeOpacity="1"
                        strokeMiterlimit="20"
                        strokeWidth="2"
                      />
                    </g>
                    <g>
                      <path
                        d="M21.12474,13.05617v0l-8.53486,8.53486v0l-8.53486,-8.53486v0"
                        fillOpacity="0"
                        fill="#ffffff"
                        strokeDashoffset="0"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        strokeOpacity="1"
                        strokeMiterlimit="20"
                        strokeWidth="2"
                      />
                    </g>
                    <g>
                      <path
                        d="M1.48987,26.79712h22.67728"
                        fillOpacity="0"
                        fill="#ffffff"
                        strokeDashoffset="0"
                        strokeLinejoin="miter"
                        strokeLinecap="round"
                        strokeOpacity="1"
                        strokeMiterlimit="20"
                        strokeWidth="2"
                      />
                    </g>
                  </g>
                </g>
              </symbol>
              <symbol viewBox="0 0 26 18" id="icon-check-service-dark">
                <title>check-service-dark</title>
                <g>
                  <g>
                    <path
                      fill="none"
                      stroke="#004a5a"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit="20"
                      strokeWidth="2"
                      d="M1 9.13v0L8.914 17v0L25 1v0"
                    />
                  </g>
                </g>
              </symbol>
              <symbol viewBox="0 0 26 18" id="icon-check-service">
                <title>check-service</title>
                <g>
                  <g>
                    <path
                      fill="none"
                      stroke="#64dca0"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit="20"
                      strokeWidth="2"
                      d="M1 9.13v0L8.914 17v0L25 1v0"
                    />
                  </g>
                </g>
              </symbol>
              <symbol viewBox="0 0 18 2" id="icon-custom-minus-icon">
                <title>custom-minus-icon</title>
                <g>
                  <g>
                    <path
                      fill="none"
                      stroke="#004a5a"
                      strokeLinecap="round"
                      strokeMiterlimit="20"
                      strokeWidth="2"
                      d="M1 1h16"
                    />
                  </g>
                </g>
              </symbol>
              <symbol viewBox="0 0 18 18" id="icon-custom-plus-icon">
                <title>custom-plus-icon</title>
                <g>
                  <g>
                    <path
                      fill="none"
                      stroke="#004a5a"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeMiterlimit="20"
                      strokeWidth="2"
                      d="M9.002 8.998v0h-8v0h8v0-8 8H17v0H9.002v8.005z"
                    />
                  </g>
                </g>
              </symbol>
              <symbol viewBox="0 0 25 24" id="icon-edit-pen">
                <title>edit-pen</title>
                <g>
                  <g>
                    <g>
                      <path
                        fill="none"
                        stroke="#4fbeef"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="20"
                        strokeWidth="2"
                        d="M7.04 17.414v0L17.84 1.29a.673.673 0 0 1 .91-.188l3.637 2.267c.305.19.393.582.196.877L11.78 20.369a.65.65 0 0 1-.254.221L7.68 22.486c-.45.222-.981-.11-.956-.596l.21-4.163a.623.623 0 0 1 .105-.313z"
                      />
                    </g>
                    <g>
                      <path
                        fill="none"
                        stroke="#4fbeef"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="20"
                        strokeWidth="2"
                        d="M15.906 4.296l4.74 3.064"
                      />
                    </g>
                    <g>
                      <path
                        fill="none"
                        stroke="#4fbeef"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="20"
                        strokeWidth="2"
                        d="M23.21 23h-22"
                      />
                    </g>
                  </g>
                </g>
              </symbol>
            </svg>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="floatinTrigerCo2Prices"
        tabIndex="-1"
        aria-labelledby="floatinTrigerCo2PricesLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-tertiary">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="floatinTrigerCo2PricesLabel">
                Hinweis zur Eingabe{" "}
                <span className="text-primary">
                  Ihres CO<sub>2</sub>-Preises
                </span>
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p className="text-large">
                In den Jahren 2026 und 2027 werden Emissionszertifikate erstmalig versteigert. Für
                diesen Zeitraum gilt ein gesetzlicher Preiskorridor zwischen 55 und 65 Euro pro
                Tonne CO<sub>2</sub>.
              </p>
              <p className="text-large">
                Ab dem Jahr 2028 wird der Preis durch den freien Handel im Emissionshandelssystem
                (EU-ETS) bestimmt. Expert:innen rechnen damit, dass sich die Preise bis 2030
                deutlich erhöhen könnten. In verschiedenen Szenarien ist sogar von bis zu 275 Euro
                pro Tonne CO<sub>2</sub> die Rede.
              </p>

              <br />

              <p className="text-large">
                <a
                  href="#"
                  target="_blank"
                  className="btn btn-default"
                  rel="noreferrer"
                  data-bs-dismiss="modal"
                >
                  Schließen
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="floatinTrigerCo2Prices2025"
        tabIndex="-1"
        aria-labelledby="floatinTrigerCo2Prices2025Label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg modal-tertiary">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="floatinTrigerCo2Prices2025Label">
                Hinweis zur Eingabe{" "}
                <span className="text-primary">
                  Ihres CO<sub>2</sub>-Preises
                </span>
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <p className="text-large">
                Der CO<sub>2</sub>-Preis wurde im Jahr 2025 gesetzlich festgelegt auf 55 Euro pro
                Tonne CO<sub>2</sub>. In den Jahren 2026 und 2027 werden Emissionszertifikate
                erstmalig versteigert. Für diesen Zeitraum gilt ein gesetzlicher Preiskorridor
                zwischen 55 und 65 Euro pro Tonne CO<sub>2</sub>.
              </p>
              <p className="text-large">
                Ab dem Jahr 2028 wird der Preis durch den freien Handel im Emissionshandelssystem
                (EU-ETS) bestimmt. Expert:innen rechnen damit, dass sich die Preise bis 2030
                deutlich erhöhen könnten. In verschiedenen Szenarien ist sogar von bis zu 275 Euro
                pro Tonne CO<sub>2</sub> die Rede.
              </p>

              <br />

              <p className="text-large">
                <a
                  href="#"
                  target="_blank"
                  className="btn btn-default"
                  rel="noreferrer"
                  data-bs-dismiss="modal"
                >
                  Schließen
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
